import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import es from "./locales/es.json";
import de from "./locales/de.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      de: { translation: de },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "es", "de"],
    interpolation: { escapeValue: false },
    // Sprint 1069.G-followup-3 — natural-language keys can contain `:` (e.g. "13:45 UTC") and `.`
    // which i18next would otherwise interpret as namespace / key separators, breaking the lookup.
    keySeparator: false,
    nsSeparator: false,
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "app_language",
      caches: ["localStorage"],
    },
    react: { useSuspense: false },
  });

export default i18n;
